// extracted by mini-css-extract-plugin
export default {"container":"ApproveAdModal_container__bajWb","checkbox":"ApproveAdModal_checkbox__U3WkN"};